import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import {Formatter} from "../../../core/services/formatter.service";
import InvoicePayment from "./InvoicePayment.model";

export default class PaymentModel extends BaseModel {
  uuid = null;
  date = Formatter.getNowAsDate();
  method = null;
  description = null;
  accounting_code = null;
  currency_uuid = null;
  invoice_payments = [];
  bank_account = null;
  reference_number = null;
  exchange_rate = null;
  fee_percent = null;

  rules = {
    date: 'required',
    method: 'required',
    currency_uuid: 'required',
    bank_account: 'required',
  };

  attributeLabels = {
    date: i18n.t('Date'),
    method: i18n.t('Method'),
    accounting_code: i18n.t('Accounting Code'),
    currency_uuid: i18n.t('Currency'),
    description: i18n.t('Description'),
    reconciled: i18n.t('Reconciled'),
    bank_account: i18n.t('Bank Account'),
    reference_number: i18n.t('Reference Number'),
    exchange_rate: i18n.t('Exchange Rate'),
    fee_percent: i18n.t('Fee Percent'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.invoice_payments = this.invoice_payments.map(item => new InvoicePayment(item));
    this.initTranslatableFields(this)
  }
}

defineTranslatableProperties(PaymentModel);
